import { useState, useEffect } from "react";

import "./styles.css";

import * as Material from "@mui/material";

import ChatsBox from "@contexts/ChatContext";

import { useLocation } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";

import { ArrowRightRounded } from "@mui/icons-material";
import { useCommunity } from "@contexts/CommunityContext";

// Componente Screen simplificado que apenas renderiza o conteúdo
export default function Screen({ children, className = "", disablePaddingBottom = false, title, fullWidth = false, onScroll = () => { }, loading: loadingScreen = false }) {
  const [snack, setSnack] = useState(null);

  const { pathname } = useLocation();

  const { loading } = useCommunity();

  window.setSnackbar = setSnack;

  document.title = "Ginastee"

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const scrollContainer = document.querySelector('.screen-content');
    if (!scrollContainer) return;

    const lastOffsetRef = { current: scrollContainer.scrollTop };

    const handleScroll = () => {
      const currentOffset = scrollContainer.scrollTop;
      const direction = currentOffset > lastOffsetRef.current ? "bottom" : "top";
      lastOffsetRef.current = currentOffset;
      onScroll({ offset: currentOffset, direction });
    };

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [onScroll])

  function TitleBreadcrumb() {
    if (typeof title === "string") title = [{ "title": title }];

    if (!title) return null;

    return (
      <div className={"title-breadcrumb csf-2 mt-3 mb-3" + (!fullWidth ? " screen-body" : "")}>
        {title.map((item, index) => (<>
          {
            index !== 0 &&
            <ArrowRightRounded />
          }
          {
            item.iconLeft || null
          }
          <h5
            key={index}
            className={`${item.url ? "pressable" : ""}`}
            onClick={() => item.url ? window.navigate(item.url) : null}
          >
            {item.title}
          </h5>
          {
            item.iconRight || null
          }
        </>
        ))}
      </div>
    );
  }

  return (
    <>
      {
        loadingScreen && <Material.LinearProgress className="loading-screen" />
      }
      {!!snack && (
        <Material.Portal>
          <Material.Snackbar
            className="custom-snackbar"
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={!!snack}
            onClose={() => setSnack(null)}
            message={snack}
            TransitionComponent={Material.Fade}
            TransitionProps={{ timeout: { enter: 0, exit: 200 } }}
            sx={{ zIndex: 9999 }}
          />
        </Material.Portal>
      )}

      <div className={"" + className + (fullWidth ? " full-width " : " screen-body") + (disablePaddingBottom ? " pb-0" : " pb-9")}>
        <TitleBreadcrumb />
        {
          children
        }
      </div>

    </>
  );
}

export { Header, Sidebar };



// Componente Chats exportado individualmente
export function Chats() {
  return (
    <>
      <div className="chats-side">
        <h5 className="sidebar-title mb-1 mt-3">CHATS</h5>
        <ChatsBox />
      </div>
    </>
  );
}
